export default "__VITE_ASSET__CSenjUYm__"